import React from 'react';
import './Testimonial.css';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import { profile3, profile4, profile5, profile6 } from '../../images';

const data = [
  {
    avatar: profile3,
    name: 'Ahmad Alkadisi',
    review: `Yassin Al-Farwan's expertise in software development, problem-solving, and innovation has greatly contributed to our project's success. A highly recommended professional with a deep understanding of programming languages and frameworks.`
  },
  {
    avatar: profile4,
    name: 'Omar Naser',
    review: `I have had the pleasure of collaborating with Yassin Al-Farwan on multiple software development projects. Their technical expertise, professionalism, and excellent communication skills make them a valuable partner. I highly recommend Yassin Al-Farwan for any software development endeavor.`
  },
  {
    avatar: profile5,
    name: 'Moath Al-Hariri',
    review: `Working with Yassin Al-Farwan has been a game-changer for our team. Their expertise in software development and commitment to quality has resulted in exceptional products that exceed our expectations. They are a true asset to any project.`
  },
  {
    avatar: profile6,
    name: 'Malak Mardene',
    review: `I highly recommend Yassin Al-Farwan for any software development needs. Their attention to detail, problem-solving skills, and ability to meet deadlines have been instrumental in the success of our projects. It's a pleasure working with such a talented developer.`
  },
];

const Testimonial = () => {
  return (
    <section id='testimonial'>
      <div className="section__wrapper">
        <div className="section__header">
          <h2 className="primary__title">Testimonials</h2>
          <p className="text__muted description">
          Trustworthy web developer. Stellar client testimonials. Startups to established businesses. Exceptional online experiences.

          </p>
        </div>
        <Swiper
          className='testimonial__container'
          modules={[Pagination]}
          spaceBetween={40}
          slidesPerView={1}
          pagination={{ clickable: true }}
          breakpoints={{
            700: {
              slidesPerView: 2,

            }
          }}
        >
          {data.map(({ avatar, name, review }, index) => {
            return (
              <SwiperSlide className='testimonial' key={index}>
                <div className="client__avatar">
                  <img src={avatar} alt={review} />
                </div>
                <h3 className="client__name">{name}</h3>
                <small className="client__review">{review}</small>
              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>
    </section>
  );
};

export default Testimonial;